import React from 'react';

const Name = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<circle cx={11} cy={8} r={3}/>
			<path
				d="m11,.5C5.2.5.5,5.2.5,11s4.7,10.5,10.5,10.5,10.5-4.71,10.5-10.5S16.8.5,11,.5Zm0,1c5.25,0,9.5,4.25,9.5,9.5,0,1.83-.53,3.54-1.43,4.99,0-.01-.02-.02-.02-.03-.1-.13-.2-.26-.3-.39-1.84-2.24-4.62-3.66-7.74-3.66s-5.9,1.42-7.74,3.66c-.1.13-.2.26-.3.39-.01.01-.02.03-.03.04-.9-1.45-1.44-3.17-1.44-5C1.5,5.75,5.75,1.5,11,1.5Zm-6.02,16.85c.09-.15.18-.3.28-.44,1.26-1.81,3.36-3,5.74-3s4.48,1.19,5.74,3c.1.14.19.29.28.43-1.64,1.35-3.74,2.16-6.02,2.16s-4.38-.81-6.02-2.15Z"
			/>
		</g>
	</svg>
);
export default Name;
